import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useTransitionStyles, useFloating, size, shift, arrow, offset, flip, hide, autoUpdate, useClick, useDismiss, useFocus, useHover, safePolygon, useRole, useInteractions, FloatingFocusManager, FloatingPortal, FloatingDelayGroup, useMergeRefs, useId, useDelayGroup, useDelayGroupContext, FloatingArrow } from "@floating-ui/react";
import * as React from "react";
import { useRef, useState, useMemo, useEffect, useCallback } from "react";
import { useCookbookContext } from "@creditornot/cb-context";
import { createCssVars, clsx, assignInlineCssVars, getPortalElement } from "@creditornot/cb-utils";
import { styled } from "@linaria/react";
import { elevationClassName, typographyClassName } from "@creditornot/cb-ingredients";
import { createPortal } from "react-dom";
import debounce from "lodash.debounce";
import "./style.css";
const getClosedStyles$1 = ({ side }) => {
  if (side === "top") {
    return { opacity: 0, transform: "translateY(-8px)" };
  }
  if (side === "bottom") {
    return { opacity: 0, transform: "translateY(8px)" };
  }
  if (side === "left") {
    return { opacity: 0, transform: "translateX(-8px)" };
  }
  if (side === "right") {
    return { opacity: 0, transform: "translateX(8px)" };
  }
  return {};
};
const getOpenedStyles$1 = ({ side }) => {
  if (side === "top" || side === "bottom") {
    return { opacity: 1, transform: "translateY(0px)" };
  }
  if (side === "left" || side === "right") {
    return { opacity: 1, transform: "translateX(0px)" };
  }
  return {};
};
function usePopoverTransition(context) {
  return useTransitionStyles(context, {
    duration: { open: 200, close: 130 },
    close: getClosedStyles$1,
    open: getOpenedStyles$1
  });
}
const usePrevious$1 = (value) => {
  const ref = useRef();
  const prev = ref.current;
  ref.current = value;
  return prev;
};
const ARROWUP_WIDTH_PX$2 = 16;
const ARROWUP_HEIGHT_PX$2 = ARROWUP_WIDTH_PX$2 / 2;
const styleParamsCssVars = createCssVars(["borderRadius"]);
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_PopoverBase_Root_r1s6",
  propsAsIs: false
});
const ArrowContainer = /* @__PURE__ */ styled("div")({
  name: "ArrowContainer",
  class: "cb_PopoverBase_ArrowContainer_a1vm",
  propsAsIs: false
});
const Content$1 = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_PopoverBase_Content_c10e",
  propsAsIs: false
});
const _exp7 = () => ArrowContainer;
const ArrowUpDownContainer = /* @__PURE__ */ styled(_exp7())({
  name: "ArrowUpDownContainer",
  class: "cb_PopoverBase_ArrowUpDownContainer_ay7z",
  propsAsIs: true
});
const _exp10 = () => ArrowContainer;
const ArrowLeftRightContainer = /* @__PURE__ */ styled(_exp10())({
  name: "ArrowLeftRightContainer",
  class: "cb_PopoverBase_ArrowLeftRightContainer_azuq",
  propsAsIs: true
});
const ArrowUp = ({
  ...props
}) => /* @__PURE__ */ jsxs("svg", {
  viewBox: "0 0 32 16",
  ...props,
  children: [/* @__PURE__ */ jsx("path", {
    className: "cb-popover-arrow-shadow",
    d: "M 16,0 L32,16 H0 Z"
  }), /* @__PURE__ */ jsx("path", {
    d: "M 16,1 L31,16 H1 Z"
  })]
});
const ArrowDown = ({
  ...props
}) => /* @__PURE__ */ jsxs("svg", {
  viewBox: "0 0 32 16",
  ...props,
  children: [/* @__PURE__ */ jsx("path", {
    className: "cb-popover-arrow-shadow",
    d: "M 0,0 L32,0 L16,16 Z"
  }), /* @__PURE__ */ jsx("path", {
    d: "M 1,0 L31,0 L16,15 Z"
  })]
});
const ArrowLeft = ({
  ...props
}) => /* @__PURE__ */ jsxs("svg", {
  viewBox: "0 0 16 32",
  ...props,
  children: [/* @__PURE__ */ jsx("path", {
    className: "cb-popover-arrow-shadow",
    d: "M0,16 L16,0 V32 Z"
  }), /* @__PURE__ */ jsx("path", {
    d: "M1,16 L16,1 V31 Z"
  })]
});
const ArrowRight = ({
  ...props
}) => /* @__PURE__ */ jsxs("svg", {
  viewBox: "0 0 16 32",
  ...props,
  children: [/* @__PURE__ */ jsx("path", {
    className: "cb-popover-arrow-shadow",
    d: "M0,0 L16,16 L0,32 Z"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0,1 L16,16 L0,31 Z"
  })]
});
const PopoverBase = React.forwardRef(({
  arrowPosition,
  arrowTipRef,
  children,
  className,
  side,
  style,
  styleParams,
  ...rest
}, ref) => /* @__PURE__ */ jsxs(Root$1, {
  className: clsx(elevationClassName.small, className),
  ref,
  style: {
    ...style,
    ...assignInlineCssVars(styleParamsCssVars, {
      borderRadius: "8px",
      ...styleParams
    })
  },
  ...rest,
  children: [arrowTipRef && side === "bottom" && /* @__PURE__ */ jsx(ArrowUpDownContainer, {
    "aria-hidden": true,
    ref: arrowTipRef,
    style: {
      left: (arrowPosition == null ? void 0 : arrowPosition.x) ?? 0,
      top: -ARROWUP_HEIGHT_PX$2 + 0.5
    },
    children: /* @__PURE__ */ jsx(ArrowUp, {
      style: {
        filter: "drop-shadow(rgba(0, 0, 0, 0.09) 0px 0px 2px)"
      }
    })
  }), arrowTipRef && side === "top" && /* @__PURE__ */ jsx(ArrowUpDownContainer, {
    "aria-hidden": true,
    ref: arrowTipRef,
    style: {
      left: (arrowPosition == null ? void 0 : arrowPosition.x) ?? 0,
      bottom: -ARROWUP_HEIGHT_PX$2 + 0.5
    },
    children: /* @__PURE__ */ jsx(ArrowDown, {
      style: {
        filter: "drop-shadow(rgba(0, 0, 0, 0.09) 0px 2px 2px)"
      }
    })
  }), arrowTipRef && side === "right" && /* @__PURE__ */ jsx(ArrowLeftRightContainer, {
    "aria-hidden": true,
    ref: arrowTipRef,
    style: {
      left: -ARROWUP_HEIGHT_PX$2 + 0.5,
      top: (arrowPosition == null ? void 0 : arrowPosition.y) ?? 0
    },
    children: /* @__PURE__ */ jsx(ArrowLeft, {
      style: {
        filter: "drop-shadow(rgba(0, 0, 0, 0.12) -2px 2px 2px)"
      }
    })
  }), arrowTipRef && side === "left" && /* @__PURE__ */ jsx(ArrowLeftRightContainer, {
    "aria-hidden": true,
    ref: arrowTipRef,
    style: {
      right: -ARROWUP_HEIGHT_PX$2 + 0.5,
      top: (arrowPosition == null ? void 0 : arrowPosition.y) ?? 0
    },
    children: /* @__PURE__ */ jsx(ArrowRight, {
      style: {
        filter: "drop-shadow(rgba(0, 0, 0, 0.12) 2px 2px 2px)"
      }
    })
  }), /* @__PURE__ */ jsx(Content$1, {
    children
  })]
}));
PopoverBase.displayName = "PopoverBase";
const ARROWUP_WIDTH_PX$1 = 16;
const ARROWUP_HEIGHT_PX$1 = ARROWUP_WIDTH_PX$1 / 2;
const getDirectionAwarePlacement$1 = (direction, placement) => {
  if (direction === "ltr") {
    return placement;
  }
  if (placement.includes("left")) {
    return placement.replace("left", "right");
  }
  if (placement.includes("right")) {
    return placement.replace("right", "left");
  }
  return placement;
};
const Popover = ({
  children,
  className,
  content,
  delayOnMouseEnter = 50,
  delayOnMouseLeave,
  fallbackPlacements,
  focusOrder = ["reference", "content"],
  hideWhenReferenceNotInViewport = true,
  initialFocus = 0,
  matchReferenceWidth,
  offset: offsetProp = 0,
  onCloseStart,
  onOpenChange,
  onOpenStart,
  open: openProp,
  openOnClick = true,
  openOnFocus = false,
  openOnHover = false,
  placement: placementProp = "top",
  portalElement = getPortalElement(),
  positioningStrategy = "absolute",
  renderArrow = true,
  rendering = "portal",
  role: roleProp = "dialog",
  style,
  styleParams,
  zIndex = 0
}) => {
  var _a, _b;
  const isControlled = openProp !== void 0;
  const arrowTipRef = useRef(null);
  const direction = ((_a = useCookbookContext()) == null ? void 0 : _a.direction) ?? "ltr";
  const [openState, setOpenState] = React.useState(false);
  const handleOpenChange = (value) => {
    if (!isControlled) {
      setOpenState(value);
    }
    onOpenChange == null ? void 0 : onOpenChange(value);
    if (value) {
      onOpenStart == null ? void 0 : onOpenStart();
    } else {
      onCloseStart == null ? void 0 : onCloseStart();
    }
  };
  const close = () => handleOpenChange(false);
  const { context, middlewareData, placement, refs, strategy, x, y } = useFloating({
    open: openProp ?? openState,
    onOpenChange: handleOpenChange,
    placement: getDirectionAwarePlacement$1(direction, placementProp),
    middleware: [
      matchReferenceWidth && size({
        apply({ rects }) {
          if (refs.floating.current) {
            Object.assign(refs.floating.current.style, {
              width: `${rects.reference.width}px`
            });
          }
        }
      }),
      shift(),
      renderArrow && arrow({ element: arrowTipRef, padding: 4 }),
      offset({ mainAxis: (renderArrow ? ARROWUP_HEIGHT_PX$1 : 0) + offsetProp }),
      flip({ fallbackPlacements }),
      hideWhenReferenceNotInViewport && hide()
    ],
    strategy: positioningStrategy,
    whileElementsMounted: autoUpdate
  });
  const prevMatchReferenceWidth = usePrevious$1(matchReferenceWidth);
  if (prevMatchReferenceWidth && !matchReferenceWidth && refs.floating.current) {
    Object.assign(refs.floating.current.style, {
      width: "auto"
    });
  }
  const { isMounted, styles } = usePopoverTransition(context);
  const placementSide = placement.split("-")[0];
  const click = useClick(context, { enabled: openOnClick });
  const dismiss = useDismiss(context);
  const focus = useFocus(context, { enabled: openOnFocus });
  const hover = useHover(context, {
    enabled: openOnHover,
    delay: { open: delayOnMouseEnter, close: delayOnMouseLeave },
    handleClose: safePolygon()
  });
  const role = useRole(context, { role: roleProp });
  const { getFloatingProps, getReferenceProps } = useInteractions([
    click,
    dismiss,
    focus,
    hover,
    role
  ]);
  const floatingProps = getFloatingProps();
  const referenceProps = getReferenceProps();
  const popover = isMounted ? /* @__PURE__ */ jsx(
    FloatingFocusManager,
    {
      closeOnFocusOut: true,
      context,
      initialFocus,
      modal: true,
      order: focusOrder,
      returnFocus: true,
      children: /* @__PURE__ */ jsx(
        PopoverBase,
        {
          ...floatingProps,
          arrowPosition: middlewareData.arrow,
          arrowTipRef: renderArrow ? arrowTipRef : void 0,
          className,
          ref: refs.setFloating,
          side: placementSide,
          style: {
            ...style,
            // floating-ui doesn't seem to resolve initial styles properly, thus this
            ...getClosedStyles$1({ side: placementSide }),
            ...styles,
            opacity: ((_b = middlewareData.hide) == null ? void 0 : _b.referenceHidden) ? 0 : styles.opacity,
            position: strategy,
            top: y ?? "0px",
            left: x ?? "0px",
            zIndex
          },
          styleParams,
          children: typeof content === "function" ? content({ close }) : content
        }
      )
    }
  ) : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    typeof children === "function" ? children({
      refProps: {
        ...referenceProps,
        ref: refs.setReference
      }
    }) : children,
    rendering === "portal" && typeof window === "object" && window.document ? /* @__PURE__ */ jsx(FloatingPortal, { preserveTabOrder: true, root: portalElement, children: popover }) : popover
  ] });
};
const defaultDelay = { open: 500, close: 150 };
const TooltipDelayGroup = ({ children }) => /* @__PURE__ */ jsx(FloatingDelayGroup, { delay: defaultDelay, children });
const ContainerDiv = /* @__PURE__ */ styled("div")({
  name: "ContainerDiv",
  class: "cb_Tooltip_ContainerDiv_csex",
  propsAsIs: false
});
const ContentDiv = /* @__PURE__ */ styled("div")({
  name: "ContentDiv",
  class: "cb_Tooltip_ContentDiv_c1a3",
  propsAsIs: false
});
const TooltipContent = ({
  data,
  ...props
}) => {
  var _a, _b;
  const id = useId();
  const {
    context,
    getFloatingProps,
    middlewareData
  } = data;
  useDelayGroup(context, {
    id
  });
  const {
    currentId,
    isInstantPhase
  } = useDelayGroupContext();
  const arrowX = ((_a = middlewareData.arrow) == null ? void 0 : _a.x) ?? 0;
  const arrowY = ((_b = middlewareData.arrow) == null ? void 0 : _b.y) ?? 0;
  const transformX = arrowX + ARROW_WIDTH / 2;
  const transformY = arrowY + ARROW_HEIGHT;
  const {
    isMounted,
    styles: transitionStyles
  } = useTransitionStyles(context, {
    duration: {
      open: isInstantPhase ? 0 : 120,
      close: !isInstantPhase || currentId === id ? 80 : 0
    },
    initial: {
      transform: "scale(0.9)",
      opacity: 0
    },
    common: ({
      side
    }) => ({
      transformOrigin: {
        top: `${transformX}px calc(100% + ${ARROW_HEIGHT}px)`,
        bottom: `${transformX}px ${-ARROW_HEIGHT}px`,
        left: `calc(100% + ${ARROW_HEIGHT}px) ${transformY}px`,
        right: `${-ARROW_HEIGHT}px ${transformY}px`
      }[side]
    })
  });
  return isMounted ? /* @__PURE__ */ jsx("div", {
    ref: context.refs.setFloating,
    style: context.floatingStyles,
    ...getFloatingProps(),
    children: /* @__PURE__ */ jsx(ContainerDiv, {
      className: elevationClassName.small,
      style: transitionStyles,
      children: /* @__PURE__ */ jsx(ContentDiv, {
        className: typographyClassName.Body3,
        ...props
      })
    })
  }) : null;
};
const ARROW_HEIGHT = 6;
const ARROW_WIDTH = ARROW_HEIGHT * 2;
const GAP = 2;
const _exp3 = () => FloatingArrow;
const ArrowBg = /* @__PURE__ */ styled(_exp3())({
  name: "ArrowBg",
  class: "cb_Tooltip_ArrowBg_ate9",
  propsAsIs: true
});
const _exp4 = () => FloatingArrow;
const Arrow = /* @__PURE__ */ styled(_exp4())({
  name: "Arrow",
  class: "cb_Tooltip_Arrow_ajj9",
  propsAsIs: true
});
function useTooltip({
  delay: delayProp,
  disabled,
  fallbackPlacements,
  onOpenChange: setControlledOpen,
  open: controlledOpen,
  placement = "top",
  renderArrow
} = {}) {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const arrowRef = useRef(null);
  const open = controlledOpen ?? uncontrolledOpen;
  const setOpen = setControlledOpen ?? setUncontrolledOpen;
  const {
    delay: delayContext
  } = useDelayGroupContext();
  const delay = delayProp ?? (delayContext !== 0 ? delayContext : defaultDelay);
  const data = useFloating({
    placement,
    open,
    onOpenChange: setOpen,
    whileElementsMounted: autoUpdate,
    middleware: [offset(ARROW_HEIGHT + GAP), flip({
      padding: 5,
      fallbackPlacements
    }), shift({
      padding: 5
    }), renderArrow && arrow({
      element: arrowRef
    })]
  });
  const context = data.context;
  const hover = useHover(context, {
    delay,
    move: false,
    enabled: !disabled && controlledOpen == null,
    handleClose: safePolygon()
  });
  const focus = useFocus(context, {
    enabled: !disabled && controlledOpen == null
  });
  const dismiss = useDismiss(context, {
    enabled: !disabled
  });
  const role = useRole(context, {
    enabled: !disabled,
    role: "tooltip"
  });
  const interactions = useInteractions([hover, focus, dismiss, role]);
  return {
    setOpen,
    arrowRef,
    ...interactions,
    ...data
  };
}
const Tooltip = ({
  children,
  content,
  disabled,
  portalElement = getPortalElement(),
  renderArrow = true,
  ...rest
}) => {
  const [hover, setHover] = useState(false);
  const data = useTooltip({
    disabled,
    renderArrow,
    ...rest
  });
  const {
    arrowRef,
    context,
    getReferenceProps
  } = data;
  const showTitle = !hover && !context.open && typeof content === "string";
  const mergedRef = useMergeRefs([(el) => {
    context.refs.setReference(el);
  }, children == null ? void 0 : children.ref]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [React.cloneElement(children, disabled ? void 0 : getReferenceProps({
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
      ref: mergedRef,
      tabIndex: 0,
      title: showTitle ? content : void 0
    })), !disabled && /* @__PURE__ */ jsx(FloatingPortal, {
      root: portalElement,
      children: /* @__PURE__ */ jsxs(TooltipContent, {
        data,
        children: [renderArrow && /* @__PURE__ */ jsx(ArrowBg, {
          context,
          height: ARROW_HEIGHT,
          ref: arrowRef,
          tipRadius: 2,
          width: ARROW_WIDTH
        }), renderArrow && /* @__PURE__ */ jsx(Arrow, {
          context,
          height: ARROW_HEIGHT,
          ref: arrowRef,
          tipRadius: 2,
          width: ARROW_WIDTH
        }), content]
      })
    })]
  });
};
function useDebounce(func, wait, options, deps = []) {
  const debouncedFnRef = useRef();
  debouncedFnRef.current = useMemo(() => {
    if (debouncedFnRef.current) {
      debouncedFnRef.current.cancel();
    }
    return debounce(func, wait, options);
  }, deps);
  useEffect(() => () => debouncedFnRef.current && debouncedFnRef.current.cancel(), []);
  return debouncedFnRef.current;
}
const usePrevious = (value) => {
  const ref = useRef();
  const prev = ref.current;
  ref.current = value;
  return prev;
};
const useLegacyPopoverState = ({
  closeOnClickInsidePopover = false,
  closeOnClickOutsidePopoverAndReference = true,
  delayOnMouseEnter = 50,
  delayOnMouseLeave = 0,
  enabled = true,
  onCloseStart,
  onOpenStart,
  showOnClick,
  showOnHover
}) => {
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const [{ show }, setState] = useState({ show: false });
  const showPrev = usePrevious(show);
  useEffect(() => {
    if (onCloseStart && !show && showPrev === true) {
      onCloseStart();
    } else if (onOpenStart && show && showPrev === false) {
      onOpenStart();
    }
  }, [onCloseStart, onOpenStart, show, showPrev]);
  const debouncedSetOpenWithEnterDelay = useDebounce(
    (value) => {
      if (mounted.current) {
        setState(value);
      }
    },
    delayOnMouseEnter,
    {
      leading: false,
      trailing: true
    },
    [delayOnMouseEnter]
  );
  const debouncedSetOpenWithLeaveDelay = useDebounce(
    (value) => {
      if (mounted.current) {
        setState(value);
      }
    },
    delayOnMouseLeave,
    {
      leading: false,
      trailing: true
    },
    [delayOnMouseLeave]
  );
  const handleMouseEnter = useMemo(() => {
    if (!enabled || !showOnHover) {
      return void 0;
    }
    return () => {
      debouncedSetOpenWithLeaveDelay && debouncedSetOpenWithLeaveDelay.cancel();
      debouncedSetOpenWithEnterDelay(
        (currentState) => !currentState.show ? { show: true, source: "hover" } : currentState
      );
    };
  }, [debouncedSetOpenWithEnterDelay, debouncedSetOpenWithLeaveDelay, enabled, showOnHover]);
  const handleMouseLeave = useMemo(() => {
    if (!enabled || !showOnHover) {
      return void 0;
    }
    return () => {
      debouncedSetOpenWithEnterDelay && debouncedSetOpenWithEnterDelay.cancel();
      debouncedSetOpenWithLeaveDelay((currentState) => {
        return currentState.show && currentState.source === "hover" ? { show: false } : currentState;
      });
    };
  }, [debouncedSetOpenWithEnterDelay, debouncedSetOpenWithLeaveDelay, enabled, showOnHover]);
  const handleClickRef = useMemo(() => {
    if (!enabled || !showOnClick) {
      return void 0;
    }
    const handler = (event) => {
      event.stopPropagation();
      setState((currentState) => {
        if (currentState.show && currentState.source !== "hover") {
          return { show: false };
        }
        return { show: true, source: "click" };
      });
    };
    return handler;
  }, [enabled, showOnClick]);
  const handleClickInside = useMemo(() => {
    if (!enabled || !closeOnClickInsidePopover) {
      return void 0;
    }
    return () => {
      setState({ show: false });
    };
  }, [closeOnClickInsidePopover, enabled]);
  const handleClickOutsideContentAndPositionRef = useMemo(() => {
    if (!enabled || !showOnClick || !closeOnClickOutsidePopoverAndReference) {
      return void 0;
    }
    return () => {
      setState({ show: false });
    };
  }, [closeOnClickOutsidePopoverAndReference, enabled, showOnClick]);
  const open = useCallback(() => {
    if (enabled) {
      setState({ show: true, source: "custom" });
    }
  }, [enabled]);
  const close = useCallback(() => {
    if (enabled) {
      setState({ show: false });
    }
  }, [enabled]);
  return {
    close,
    open,
    popoverHandlers: {
      show,
      onClickInside: handleClickInside,
      onClickOutsideContentAndPositionRef: handleClickOutsideContentAndPositionRef,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    },
    referenceHandlers: {
      onClick: handleClickRef,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }
  };
};
const useOnClickInside = (refs, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (refs.some((ref) => {
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.contains(event.target);
      })) {
        handler(event);
      }
    };
    document.addEventListener("click", listener, { capture: true });
    return () => {
      document.removeEventListener("click", listener, { capture: true });
    };
  }, [handler, ...refs]);
};
const useOnClickOutside = (refs, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (refs.every((ref) => {
        var _a;
        return !((_a = ref.current) == null ? void 0 : _a.contains(event.target));
      })) {
        handler(event);
      }
    };
    document.addEventListener("click", listener, { capture: true });
    return () => {
      document.removeEventListener("click", listener, { capture: true });
    };
  }, [handler, ...refs]);
};
const POPOVER_OFFSET_PX = 4;
const ARROWUP_WIDTH_PX = 16;
const ARROWUP_HEIGHT_PX = ARROWUP_WIDTH_PX / 2;
const HOVER_AREA_WIDTH = ARROWUP_HEIGHT_PX + POPOVER_OFFSET_PX;
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_LegacyPopover_Root_r1ri",
  propsAsIs: false
});
const _exp = () => ({
  $padded
}) => $padded ? "8px" : "0px";
const Content = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_LegacyPopover_Content_ci7q",
  propsAsIs: false,
  vars: {
    "ci7qmbf-0": [_exp()]
  }
});
const isFloatingUiReferenceRegularElement = (ref) => Boolean(ref.current && typeof ref.current === "object" && "classList" in ref.current);
const getDirectionAwarePlacement = (direction, placement) => {
  if (direction === "ltr") {
    return placement;
  }
  if (placement.includes("left")) {
    return placement.replace("left", "right");
  }
  if (placement.includes("right")) {
    return placement.replace("right", "left");
  }
  return placement;
};
const getClosedStyles = ({
  side
}) => {
  if (side === "top") {
    return {
      opacity: 0,
      transform: "translateY(-8px)"
    };
  }
  if (side === "bottom") {
    return {
      opacity: 0,
      transform: "translateY(8px)"
    };
  }
  if (side === "left") {
    return {
      opacity: 0,
      transform: "translateX(-8px)"
    };
  }
  if (side === "right") {
    return {
      opacity: 0,
      transform: "translateX(8px)"
    };
  }
  return {};
};
const getOpenedStyles = ({
  side
}) => {
  if (side === "top" || side === "bottom") {
    return {
      opacity: 1,
      transform: "translateY(0px)"
    };
  }
  if (side === "left" || side === "right") {
    return {
      opacity: 1,
      transform: "translateX(0px)"
    };
  }
  return {};
};
let globalMountElement = null;
const getGlobalMountElement = () => {
  if (globalMountElement) {
    return globalMountElement;
  }
  const mountElement = document && document.querySelector(".cb-popover-portal");
  if (mountElement) {
    globalMountElement = mountElement;
    return globalMountElement;
  }
  globalMountElement = document.createElement("div");
  globalMountElement.className = "cb-popover-portal";
  document.body.append(globalMountElement);
  return globalMountElement;
};
const HoverArea = /* @__PURE__ */ styled("div")({
  name: "HoverArea",
  class: "cb_LegacyPopover_HoverArea_hj4d",
  propsAsIs: false
});
const LegacyPopover = ({
  boundariesElement = "viewport",
  children,
  className,
  closeOnClickInside = false,
  closeOnClickOutside = true,
  content,
  contentZIndex,
  delayOnMouseEnter = 50,
  delayOnMouseLeave = 0,
  disableContentPadding = false,
  disabled,
  fallbackPlacements,
  hideWhenOutOfView = true,
  onClickInside,
  onClickOutside,
  onCloseStart,
  onOpenStart,
  placement: placementProp = "auto",
  portalElement = getGlobalMountElement(),
  positionStrategy = "fixed",
  renderArrow = true,
  show: showProp,
  showOnClick = true,
  showOnHover = true,
  style
}) => {
  var _a, _b;
  const direction = ((_a = useCookbookContext()) == null ? void 0 : _a.direction) ?? "ltr";
  const arrowTipRef = useRef(null);
  const controlledMode = showProp !== void 0;
  const popoverState = useLegacyPopoverState({
    closeOnClickInsidePopover: closeOnClickInside,
    closeOnClickOutsidePopoverAndReference: closeOnClickOutside,
    delayOnMouseEnter,
    delayOnMouseLeave,
    enabled: !controlledMode && !disabled,
    onCloseStart,
    onOpenStart,
    showOnClick,
    showOnHover
  });
  const show = controlledMode ? showProp : popoverState.popoverHandlers.show;
  const handleClickInside = (event) => {
    var _a2, _b2;
    if (!controlledMode && !disabled) {
      (_b2 = (_a2 = popoverState.popoverHandlers).onClickInside) == null ? void 0 : _b2.call(_a2, event);
    }
    onClickInside == null ? void 0 : onClickInside(event);
  };
  const handleClickOutsideContentAndPositionRef = (event) => {
    var _a2, _b2;
    if (!controlledMode && !disabled) {
      (_b2 = (_a2 = popoverState.popoverHandlers).onClickOutsideContentAndPositionRef) == null ? void 0 : _b2.call(_a2, event);
    }
    if (show) {
      onClickOutside == null ? void 0 : onClickOutside(event);
    }
  };
  const renderProps = useMemo(() => ({
    close: popoverState.close,
    open: popoverState.open
  }), [popoverState.close, popoverState.open]);
  const {
    context,
    middlewareData,
    placement,
    refs,
    strategy,
    x,
    y
  } = useFloating({
    open: show,
    placement: getDirectionAwarePlacement(direction, placementProp === "auto" ? "top" : placementProp),
    middleware: [
      renderArrow && arrow({
        element: arrowTipRef,
        padding: 4
      }),
      // Disable shift middleware if crossAxis flipping is enabled
      // https://floating-ui.com/docs/flip#combining-with-shift
      shift(),
      offset({
        mainAxis: (renderArrow ? ARROWUP_HEIGHT_PX : 0) + POPOVER_OFFSET_PX
      }),
      flip({
        mainAxis: true,
        crossAxis: false,
        fallbackPlacements,
        fallbackStrategy: "initialPlacement"
      }),
      hideWhenOutOfView && hide({
        rootBoundary: boundariesElement
      })
    ],
    strategy: positionStrategy,
    whileElementsMounted: autoUpdate
  });
  const {
    isMounted,
    styles
  } = useTransitionStyles(context, {
    duration: {
      open: 200,
      close: 130
    },
    close: getClosedStyles,
    open: getOpenedStyles
  });
  const placementSide = placement.split("-")[0];
  useOnClickInside([refs.floating], handleClickInside);
  useOnClickOutside(
    isFloatingUiReferenceRegularElement(refs.reference) ? [refs.reference, refs.floating] : [refs.floating, refs.floating],
    // deps array length shall not change
    handleClickOutsideContentAndPositionRef
  );
  const popover = isMounted ? /* @__PURE__ */ jsxs(PopoverBase, {
    arrowPosition: middlewareData.arrow,
    arrowTipRef: renderArrow ? arrowTipRef : void 0,
    onMouseEnter: popoverState.popoverHandlers.onMouseEnter,
    onMouseLeave: popoverState.popoverHandlers.onMouseLeave,
    ref: refs.setFloating,
    role: "dialog",
    side: placementSide,
    style: {
      // floating-ui doesn't seem to resolve initial styles properly, thus this
      ...getClosedStyles({
        side: placementSide
      }),
      ...styles,
      opacity: ((_b = middlewareData.hide) == null ? void 0 : _b.referenceHidden) ? 0 : styles.opacity,
      position: strategy,
      top: y ?? "0px",
      left: x ?? "0px",
      zIndex: contentZIndex
    },
    children: [placementSide === "bottom" && /* @__PURE__ */ jsx(HoverArea, {
      style: {
        left: 3,
        right: 3,
        top: -HOVER_AREA_WIDTH,
        height: HOVER_AREA_WIDTH
      }
    }), placementSide === "top" && /* @__PURE__ */ jsx(HoverArea, {
      style: {
        left: 3,
        right: 3,
        bottom: -HOVER_AREA_WIDTH,
        height: HOVER_AREA_WIDTH
      }
    }), placementSide === "right" && /* @__PURE__ */ jsx(HoverArea, {
      style: {
        top: 3,
        bottom: 3,
        left: -HOVER_AREA_WIDTH,
        width: HOVER_AREA_WIDTH
      }
    }), placementSide === "left" && /* @__PURE__ */ jsx(HoverArea, {
      style: {
        top: 3,
        bottom: 3,
        right: -HOVER_AREA_WIDTH,
        width: HOVER_AREA_WIDTH
      }
    }), /* @__PURE__ */ jsx(Content, {
      $padded: !disableContentPadding,
      children: typeof content === "function" ? content(renderProps) : content
    })]
  }) : null;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Root, {
      ...popoverState.referenceHandlers,
      className,
      ref: refs.setReference,
      style,
      children: typeof children === "function" ? children(renderProps) : children
    }), portalElement !== null && typeof window === "object" && window.document ? createPortal(popover, portalElement) : popover]
  });
};
export {
  LegacyPopover,
  Popover,
  PopoverBase,
  Tooltip,
  TooltipDelayGroup,
  getClosedStyles$1 as getClosedStyles,
  usePopoverTransition
};
//# sourceMappingURL=index.js.map
